import React, { useEffect, useState } from "react";
import api from "../services/api";
import Loader from "../components/Loader";
import { useHistory, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import ContainerHome from "../components/ContainerHome";
import { Button } from "react-bootstrap";

const ConfirmedScreen = () => {
  let history = useHistory();
  const { tokenx } = useParams();
  const [loading, setLoading] = useState(false);

  const confirmedToken = async () => {
    setLoading(true);
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const resp = await api.post(
      "/api/users/emailx",
      { tokenemail: tokenx },
      config
    );
    return resp.data;
  };

  const handleClick = () => {
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    api.defaults.headers.Authorization = undefined;
    history.push("/login");
  };

  useEffect(() => {
    // eslint-disable-next-line
    if (tokenx) {
      confirmedToken()
        .then((tkemail) => {
          toast.success(
            "Cadastro confirmado! Favor entrar com suas credenciais."
          );

          setTimeout(function () {
            setLoading(false);
            handleClick();
          }, 2000);
        })
        .catch((error) => {
          toast.error("Erro ao tentar confirmar cadastro!");

          setTimeout(function () {
            setLoading(false);
            handleClick();
          }, 2000);
        });
    }
     // eslint-disable-next-line
  }, []);

  return (
    <>
      <ToastContainer />

      {loading ? (
        <Loader />
      ) : (
        <>
          <ContainerHome>
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row text-center">
                  <img
                    src="img/confirmed.png"
                    className="img-fluid"
                    width="100%"
                    height="100%"
                    alt="Confirmação do e-mail"
                  />

                  <Button
                    className="btn btn-warning btn-lg mt-5 mb-5"
                    onClick={handleClick}
                  >
                    {" "}
                    <i className="fas fa-angle-left"></i> Clique aqui para
                    Retornar{" "}
                  </Button>
                </div>
              </div>
            </div>
          </ContainerHome>
        </>
      )}
    </>
  );
};

export default ConfirmedScreen;
